/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
    name: 'Paginator',

    props: {
        max: {
            type: Number,
            required: true
        },

        current: {
            type: Number,
            required: true
        },

        showPageNumbers: {
            type: Boolean,
            default: true,
        }
    },

    data() {
        return {
            pageSpreadLength: 5,
            numberSeparator: '…'
        };
    },

    computed: {
        /** @returns {Array<Number|String>} */
        numberList() {
            const { current, max, numberSeparator: separator } = this;
            if (max <= 5) {
                return Array.from(Array(max)).map((_, i) => i + 1);
            }
            let list = [current - 2, current - 1, current, current + 1, current + 2].filter(d => d >= 1 && d <= max);
            if (list[0] !== 1) {
                list = list[0] === 2 ? [1, ...list] : [1, list[0] === 3 ? 2 : separator, ...list];
            }
            if (!list.includes(max)) {
                const last = list[list.length - 1];
                if (last !== max - 1) {
                    list.push(last === max - 2 ? max - 1 : separator);
                }
                list.push(max);
            }
            return list;
        }
    },

    methods: {
        /**
         * Emits an event to indicate the selected page if it's not the current one.
         * @param {Object} pageNumber the selected page number
         */
        selectPage(pageNumber) {
            if (pageNumber !== this.current && pageNumber !== this.numberSeparator) {
                this.$emit('select-page', pageNumber);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.numberList.length > 1),expression:"numberList.length > 1"}],staticClass:"paginator"},[_c('button',{staticClass:"page-number btn btn-icon single",attrs:{"type":"button","disabled":_vm.current === 1},on:{"click":function($event){return _vm.$emit('previous')}}},[_c('i',{staticClass:"ic-chevron-left"})]),_vm._l((_vm.numberList),function(number){return (_vm.showPageNumbers)?_c('button',{staticClass:"page-number btn",class:{ primary: number === _vm.current , 'number-separator' : number === _vm.numberSeparator},attrs:{"type":"button","disabled":number === _vm.numberSeparator},on:{"click":function($event){return _vm.selectPage(number)}}},[_vm._v(_vm._s(number))]):_vm._e()}),_c('button',{staticClass:"page-number btn btn-icon single",attrs:{"type":"button","disabled":_vm.current === _vm.max},on:{"click":function($event){return _vm.$emit('next')}}},[_c('i',{staticClass:"ic-chevron-right"})])],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Paginator.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__